import { useState } from 'react';
import { CasCRUDTable, CasRenderArrayAsRows, CasRenderBoolTrue } from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import { Terms } from 'src/compass/shared/util/terms';
import { CasYesNoSelect, CasRiskWithSalesManagerSelect, CasSourceSelect } from 'src/compass/application';
import CustomerDialog from './CustomerDialog';
import CustomerForm from './CustomerForm';
import ServiceOwnerFilterSelect from './ServiceOwnerFilterSelect';

export default function CustomersTab() {
  const [dialogRowId, setDialogRowId] = useState<number | null>(null);
  const [reloadTable, setReloadTable] = useState(new Date());

  const closeDialog = () => {
    setDialogRowId(null);
    setReloadTable(new Date());
  };

  return (
    <>
      <CasCRUDTable
        entityTitle={Terms.Customer.label}
        entity="Utilities/Entity"
        reloadTable={reloadTable}
        columns={[
          {
            field: 'name',
            render: ({ row, column }: ICasRenderCellProps) => (
              <CasLink onClick={() => setDialogRowId(row.id)}>{getCasTableCellValue({ row, column })}</CasLink>
            ),
          },
          {
            field: 'crmName',
            label: Terms.CRM.label,
            sortable: false,
            render: ({ row }: ICasRenderCellProps) => {
              const { crmType, crmName } = row;
              if(!crmType) return null;
              return `${crmType}: ${crmName}`;
            }
          },
          {
            field: 'contacts',
            sortable: false,
            render: CasRenderArrayAsRows,
          },
          {
            field: 'rmcOfRecord',
            label: 'Service Owner',
          },
          {
            field: 'splits',
            label: 'Splits',
            sortable: false,
            render: CasRenderArrayAsRows,
          },
          {
            field: 'acctAltRmc',
            label: 'Accts w/alt RMC',
            sortable: false,
            render: CasRenderArrayAsRows,
          },
          {
            field: 'source',
          },
          {
            field: 'type',
          },
          {
            field: 'handoffRequested',
            label: 'Handoff',
            sortable: false,
            render: ({ row }: ICasRenderCellProps) =>
              row.handoffRequested ? `Req by ${row.handoffRequestedByName}` : '',
          },
          {
            field: 'inactive',
            render: CasRenderBoolTrue,
          },
        ]}
        filters={[
          {
            name: 'search',
          },
          {
            type: 'component',
            name: 'unassigned',
            label: 'Unassigned?',
            initialValue: true,
            includeAllOption: true,
            component: CasYesNoSelect,
          },
          {
            type: 'component',
            name: 'rmcOfRecordEmployeeId',
            label: 'Service Owner',
            component: ServiceOwnerFilterSelect,
          },
          {
            type: 'component',
            name: 'sourceEmployeeId',
            label: 'Source',
            includeAllOption: true,
            component: CasRiskWithSalesManagerSelect,
          },
          {
            type: 'component',
            name: 'sourceId',
            label: 'Type',
            includeAllOption: true,
            component: CasSourceSelect,
          },
          {
            type: 'component',
            name: 'handoffRequested',
            label: 'Handoff Requested',
            includeAllOption: true,
            component: CasYesNoSelect,
          },
          {
            type: 'component',
            name: 'inactive',
            includeAllOption: true,
            component: CasYesNoSelect,
          },
        ]}
        includeExport={false}
        editForm={CustomerForm}
      />
      {dialogRowId && <CustomerDialog id={dialogRowId} onClose={() => closeDialog()} />}
    </>
  );
}
